export default {
    formatDuration(durationInSeconds) {
        if (durationInSeconds === 0) {
            return "instantes";
        }
        if (!durationInSeconds) {
            return "-";
        }

        let seconds = Number(durationInSeconds);
        let d = Math.floor(seconds / (3600 * 24));
        let h = Math.floor(seconds % (3600 * 24) / 3600);
        let m = Math.floor(seconds % 3600 / 60);
        let s = Math.floor(seconds % 60);

        let dDisplay = d > 0 ? d + (d == 1 ? " dia, " : " dias, ") : "";
        let hDisplay = (h > 0 || d > 0) ? h + (h == 1 ? " hora, " : " horas, ") : "";
        let mDisplay = (m > 0 || d > 0 || h > 0) ? m + (m == 1 ? " minuto, " : " minutos, ") : "";
        let sDisplay = s + (s == 1 ? " segundo" : " segundos");
        let result = dDisplay + hDisplay + mDisplay;


        if (result.endsWith(", ")) {
            result = result.substring(0, result.length - 2);
            result = result + " e " + sDisplay;
        } else {
            result = sDisplay;
        }

        return result;
    },

    formatTimestamp(timestamp) {
        if (!timestamp) {
            return "-";
        }
        return new Date(Number(timestamp)).toLocaleString();
    },
}